const Check = ({ bg_color = "#2EAB92", fg_color = "#FFF8F1" }) =>
  <svg
    className="flex-shrink-0 mt-1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z"
      fill={bg_color}
    />
    <path
      d="M11.6464 5.14645C11.8417 4.95118 12.1582 4.95118 12.3535 5.14645C12.5487 5.34171 12.5487 5.65822 12.3535 5.85348L7.35348 10.8535C7.15822 11.0487 6.84171 11.0487 6.64645 10.8535L4.14645 8.35348C3.95118 8.15822 3.95118 7.84171 4.14645 7.64645C4.34171 7.45118 4.65822 7.45118 4.85348 7.64645L6.99996 9.79293L11.6464 5.14645Z"
      fill={fg_color}
    />
  </svg>

export default Check;
